export const MESSAGES = {
    LOAD_VIDEO_FAILED: 'Failed to fetch video details.',
    LOAD_CHALLENGE_FAILED: 'Failed to fetch challenge details.',
    LOAD_USER_HISTORY_FAILED: 'Failed to create user history.'
}